import { apiClient } from "./client";
import type { CornerstoneConnectRequest, CornerstoneStatus } from "@/types";

const BASE = "/api/v1/integrations/cornerstone";

export async function getCornerstoneStatus(): Promise<CornerstoneStatus> {
  try {
    const { data } = await apiClient.get<CornerstoneStatus>(BASE);
    return data;
  } catch (err: any) {
    if (err?.status === 404 || err?.response?.status === 404) {
      return {
        connected: false,
        status: null,
        hub_url: null,
        api_key_hint: null,
        last_error: null,
        last_synced_at: null,
        poll_minutes: 5,
      };
    }
    throw err;
  }
}

/** Validates the API key with Cornerstone Hub, then stores it encrypted. Never returned. */
export async function connectCornerstone(req: CornerstoneConnectRequest): Promise<CornerstoneStatus> {
  const { data } = await apiClient.put<CornerstoneStatus>(BASE, req);
  return data;
}

export async function testCornerstone(): Promise<CornerstoneStatus> {
  const { data } = await apiClient.post<CornerstoneStatus>(`${BASE}/test`);
  return data;
}

export async function syncCornerstone(): Promise<void> {
  await apiClient.post(`${BASE}/sync`);
}

export async function disconnectCornerstone(): Promise<void> {
  await apiClient.delete(BASE);
}
